import GlobalStateContext from "contexts/GlobalStateContext";
import { useContext } from "react";

export default function usePublishWorkBlockModal() {
  const { state, setState: updateGlobalState } = useContext(GlobalStateContext);

  const setState = (args) => {
    const newState = { ...state.workBlock, ...args };
    updateGlobalState({ publishWorkBlockModalState: newState });
  };

  return {
    close: () => setState({ isOpen: false }),
    isOpen: state.publishWorkBlockModalState.isOpen,
    open: (workBlock) => setState({ isOpen: true, workBlock }),
    workBlock: state.publishWorkBlockModalState.workBlock,
  };
}
